import React from "react";
import { Tooltip } from "../input";

function StackedProgressBar({ data, suffixText }) {
  return (
    <>
      <div className="w-full flex flex-row overflow-hidden cursor-default">
        {data &&
          data.map((item, i) => {
            let capitalLetterLabel =
              item.label.toString().charAt(0).toUpperCase() +
              item.label.toString().slice(1);
            return (
              <div
                key={`progress-${i}`}
                className=""
                style={{
                  width: item.percentage + "%",
                }}
              >
                <div
                  className={`${
                    item.label === "Available" ? "text-end" : ""
                  } text-xs w-full truncate capitalize`}
                >
                  {item.percentage > 5 ? (
                    <>
                      {capitalLetterLabel} <span>{item.percentage}</span>%
                    </>
                  ) : (
                    <>&nbsp;</>
                  )}
                </div>
                <Tooltip text={capitalLetterLabel} placement="top">
                  <div
                    style={{
                      background: item.color,
                    }}
                    className={`h-2 ${
                      i === 0
                        ? "rounded-l-full "
                        : data.length === i + 1
                        ? "rounded-r-full "
                        : ""
                    }`}
                  ></div>
                </Tooltip>
              </div>
            );
          })}
      </div>
    </>
  );
}

export default StackedProgressBar;
